import api from "../api/axios";
import { DocumentsAPI } from "../api/documents";
import { desktop, toast, type PrintCategory } from "./desktop";
import { getLabelSize } from "./labelSize";

/** Какой принтер нужен для документа: этикетки — на термопринтер, чеки — на чековый, остальное — A4 */
export function categoryFor(docType: string): PrintCategory {
  if (docType === "intake_label") return "label";
  if (docType === "receipt") return "receipt";
  return "a4";
}

const toBase64 = (buf: ArrayBuffer) => {
  const bytes = new Uint8Array(buf);
  let bin = "";
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode.apply(null, Array.prototype.slice.call(bytes.subarray(i, i + 0x8000)) as number[]);
  return btoa(bin);
};

/** Отправить документ на печать. force — игнорировать флаг «автопечать» (ручная кнопка). */
export async function printDocument(doc: { id: number; type: string }, force = false): Promise<boolean> {
  if (!desktop) return false;
  const category = categoryFor(doc.type);
  const cfg = (await desktop.getPrintSettings())[category];
  if (!force && !cfg.auto) return false;
  if (!cfg.printer) {
    toast("Не выбран принтер для печати. Откройте «Настройки печати» (значок внизу слева).", "error");
    return false;
  }
  try {
    // этикетка приёма печатается тем же путём, что и ценники (системная печать Chrome с точным размером страницы):
    // через PDF драйвер этикеточного принтера подставлял свой размер бумаги и сдвигал/обрезал печать
    if (doc.type === "intake_label" && (desktop as any).printHtml) {
      const size = getLabelSize();
      const { data } = await api.get(`/documents/label-html/${doc.id}`, { params: { w: size.w, h: size.h } });
      const r = await (desktop as any).printHtml({ html: data.html, kind: "labels", sizeMm: { w: data.widthMm, h: data.heightMm } });
      if (!r?.ok) { toast(`Не удалось напечатать: ${r?.reason ?? "ошибка принтера"}`, "error"); return false; }
      toast(`Отправлено на печать: ${cfg.printer}`);
      return true;
    }
    const res = await api.get(`/documents/secure-download/${doc.id}`, { responseType: "arraybuffer" });
    const r = await desktop.print(toBase64(res.data as ArrayBuffer), category);
    if (!r.ok) { toast(`Не удалось напечатать: ${r.error ?? "ошибка принтера"}`, "error"); return false; }
    toast(`Отправлено на печать: ${r.printer}`);
    return true;
  } catch {
    toast("Не удалось получить документ для печати (нет связи с сервером?)", "error");
    return false;
  }
}

/** После создания документа: напечатать его и связанные (акт приёма → ещё и этикетку) по правилам автопечати */
export async function autoPrintCreated(dealId: number, types: string[]) {
  if (!desktop) return;
  try {
    const docs: any[] = await DocumentsAPI.getByDeal(dealId);
    for (const type of types) {
      const doc = docs.filter((d) => d.type === type).sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt))[0];
      if (doc) await printDocument(doc);
    }
  } catch { /* печать не должна ломать создание документа */ }
}
